module.exports = __webpack_public_path__ + "media/site/images/banners/banner-brief-mobile-404347918d41532cb6cc7e377dff5871.svg";